// extracted by mini-css-extract-plugin
export default {"zoomModal":"M3-z"};